import { createApp, ref } from 'vue';

import Loader from '@/Components/Loader.vue';

import useAuth from '@/VueWorking/useAuth.js';
import router from '@/VueWorking/router.js';
import store from '@/VueWorking/store.js';
import sessionCheck from '@/VueWorking/sessionCheck.js';

import HeaderPage from '@/VueWorking/Components/HeaderPage.vue';
import FooterPage from '@/VueWorking/Components/FooterPage.vue';

import Modal from '@/VueWorking/Components/Modal.vue';
import SessionTimer from '@/VueWorking/Components/SessionTimer.vue';
import EmployeeWorks from '@/VueWorking/Components/EmployeeWorks.vue';


const clickOutsideDirective = {
    // добавляем эвент для тыка вне компонента
    beforeMount(el, binding) {
        el.clickOutsideEvent = function (event) {
            if (!(el == event.target || el.contains(event.target))) {
                binding.value(event, el);
            }
        };
        document.body.addEventListener('click', el.clickOutsideEvent)
    },
    unmounted(el) {
        // нужно удалять эвенты, берегите ОЗУ клиентов
        document.body.removeEventListener('click', el.clickOutsideEvent);
    }
};


const { attempt } = useAuth()
// const { attemptSession, refreshSession } = sessionCheck()
const app = createApp({});
// use v-click-outside="yourMethod"
app.directive('click-outside', clickOutsideDirective);

app.use(store);
app.use(router);

app.component('vue-modal', Modal);
app.component('vue-loader', Loader);
app.component('vue-session-timer', SessionTimer);
app.component('vue-header-page', HeaderPage);
app.component('vue-footer-page', FooterPage);
app.component('vue-working-employee-works', EmployeeWorks);

attempt().then(() => {
    app.mount('#app-vue-employee');
})
// app.mount('#app-vue-employee');

const intervalSessionId = setInterval(() => {
    store.state.sessionTime.time--;
    if(store.state.sessionTime.time <= 10){
        sessionCheck().refreshSession();
    }
}, 1000);
